import PropTypes from 'prop-types';
import React from 'react';

import { withRouter } from 'react-router';
import { EmitPage } from '../../../Analytics/VisibilityPixel/VisibilityPixel';

import './HomePageWrapper.scss';

export class HomePageWrapper extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        modalTrigger: PropTypes.func,
        scrollOffset: PropTypes.number,
        isMobileBreakpoint: PropTypes.bool,
    };

    static defaultProps = {
        modalTrigger: () => {},
        scrollOffset: 0,
        isMobileBreakpoint: false,
    };

    componentDidUpdate(prevProps) {
        const {
            scrollOffset,
            location,
            modalTrigger,
            isMobileBreakpoint,
        } = this.props;

        if (location.pathname !== prevProps.location.pathname) {
            /*
                listen for client-side route change and on change, do the following
                - fire page metrics
                - scroll to main content (on mobile screens less than 576px)
                - close any open modal
            */
            modalTrigger(null);
            EmitPage(null, true);
            if (isMobileBreakpoint) {
                window.scrollTo({
                    left: 0,
                    top: scrollOffset,
                    behavior: 'smooth',
                });
            }
        }
    }

    render() {
        const { children } = this.props;

        return (
            <div className="component-Groups-Navigation-HomePageWrapper">
                {children}
            </div>
        );
    }
}

export default withRouter(HomePageWrapper);
